import I18NextVue from 'i18next-vue'
import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { initI18n } from 'www/utils'
import DoctorCases from 'www/vue_components/common/DoctorCases/DoctorCases.vue'

const init = async () => {
  const el = document.querySelector('.vue-doctor-cases-mount')

  if (el) {
    const { i18next } = await initI18n({ bundle: 'vue_components/common/DoctorCases' })

    Vue.use(I18NextVue, { i18next })

    new Vue({
      el,
      vuetify,
      name: 'DoctorCasesRoot',
      components: {
        DoctorCases,
      },
    })
  }
}

init()
